import { MetricRef } from './types';

const isProbablyDataKey = (value: string) => {
  // Отсекаем старые индексные ключи дерева вида "0-1-2"
  if (/^\d+(?:-\d+)+$/.test(value)) return false;
  // dataKey обычно содержит буквы/подчёркивания/цифры, иногда префиксы/суффиксы (_2, _cumulative и т.п.)
  return /[a-zA-Z_]/.test(value);
};

export const normalizeMetricRef = (input: unknown): MetricRef | null => {
  if (!input) return null;

  // Строка — считаем, что это dataKey
  if (typeof input === 'string') {
    const dataKey = input;
    if (!isProbablyDataKey(dataKey)) return null;
    return { dataKey, name: dataKey, label: dataKey };
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const obj: any = input;

  const rawDataKey: unknown =
    typeof obj.dataKey === 'string'
      ? obj.dataKey
      : typeof obj.name === 'string'
        ? obj.name
        : typeof obj.key === 'string'
          ? obj.key
          : undefined;

  if (typeof rawDataKey !== 'string') return null;
  if (!isProbablyDataKey(rawDataKey)) return null;

  const dataKey = rawDataKey;
  const label: string | undefined =
    typeof obj.label === 'string'
      ? obj.label
      : typeof obj.title === 'string'
        ? obj.title
        : typeof obj.name === 'string' && obj.name !== dataKey
          ? obj.name
          : undefined;

  const ref: MetricRef = {
    dataKey,
    name: label ?? dataKey,
    label: label ?? dataKey,
  };

  if (obj.id != null) ref.id = obj.id;
  if (obj.plan != null) ref.plan = obj.plan;
  if (typeof obj.base_metric_name === 'string') ref.base_metric_name = obj.base_metric_name;
  if (typeof obj.metric_formula === 'string') ref.metric_formula = obj.metric_formula;

  return ref;
};

export const normalizeMetricRefs = (inputs: unknown[]): MetricRef[] => {
  const list = Array.isArray(inputs) ? inputs : [];
  const seen = new Set<string>();
  const result: MetricRef[] = [];

  for (let i = 0; i < list.length; i++) {
    const ref = normalizeMetricRef(list[i]);
    if (!ref) continue;
    if (seen.has(ref.dataKey)) continue;
    seen.add(ref.dataKey);
    result.push(ref);
  }

  return result;
};

// ==================== Helpers ====================

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getMetricDataKey = (metric: any): string => {
  if (!metric) return '';
  if (typeof metric.dataKey === 'string' && metric.dataKey) return metric.dataKey;
  if (typeof metric.name === 'string' && metric.name) return metric.name;
  return '';
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const hasMetricByDataKey = (metrics: any[], dataKey: string): boolean => {
  if (!Array.isArray(metrics) || !dataKey) return false;
  return metrics.some((m) => getMetricDataKey(m) === dataKey);
};

